import {useSelector} from 'react-redux';
import {Role} from '../Admin/GraphQL/global-types';
import {RootState} from '../Store';

export const useHasRole = (role: Role) => {
  const userRole = useSelector<RootState, Role | undefined>(state => state.authentication.decodedToken?.user.role);

  return userRole === role;
};
